module.exports = __webpack_public_path__ + "img/FFQS0317-05.7434b7b3.jpg";